document.addEventListener("DOMContentLoaded", function() {
  const productCards = document.querySelectorAll("product-card");

  const validSizes = [
    "XS","X-SMALL","S","SMALL","M","MEDIUM","L","LARGE","XL","X-LARGE","XXL","XXXL",
    "IT 36","IT 36.5","IT 37","IT 37.5","IT 38","IT 38.5","IT 39","IT 39.5","IT 40","IT 40.5",
    "IT 41","IT 41.5","IT 42","IT 42.5","IT 43","IT 43.5","IT 44","IT 44.5","IT 45","IT 45.5",
    "IT 46","IT 46.5","IT 47","IT 47.5","IT 48","IT 48.5","IT 49","IT 49.5","IT 50",
    "FR 32","FR 34","FR 36","FR 38","FR 40","FR 42","FR 44","FR 46","FR 48","FR 50",
    "JP 1","JP 2","JP 3","JP 4","JP 5","JP 6","JP 7","JP 8",
    "5","5.5","6","6.5","7","7.5","8","8.5","9","9.5","10","10.5","11","11.5","12","12.5","13",
    "36","36.5","37","37.5","38","38.5","39","39.5","40","40.5","41","41.5","42","42.5","43","43.5","44","44.5","45","45.5","46","46.5","47","47.5","48","48.5","49","49.5","50",
    "24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40"
  ];

  productCards.forEach(card => {
    const variantData = card.getAttribute("data-current_variant");
    if (!variantData) return;

    try {
      const variant = JSON.parse(variantData.replace(/&quot;/g,'"'));
      const hasMultipleOptions = (variant.option2 && variant.option2.trim() !== "") || 
                                 (variant.option3 && variant.option3.trim() !== "");
      const rawOption = variant.option1 ? variant.option1.trim().toUpperCase() : "";
      const size = (hasMultipleOptions && validSizes.includes(rawOption)) ? variant.option1 : null;

      if (!size || card.querySelector(".product-size-collection")) return;

      const sizeEl = document.createElement("div");
      sizeEl.className = "product-size-collection";
      sizeEl.textContent = size;

      const titleEl = card.querySelector(".product-grid--title");
      if (titleEl) {
        // Set flex column with tight spacing
        titleEl.style.display = "flex";
        titleEl.style.flexDirection = "column";
        titleEl.style.alignItems = "flex-start";
        titleEl.style.gap = "2px"; // tight spacing between title and size

        titleEl.appendChild(sizeEl);
      }

    } catch(e) {
      console.error("Error parsing variant data", e);
    }
  });
});
